export const US_STATES = Object.freeze([
  { value: '', label: ' — United States — ', disabled: true },
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
]);

export const FORM_VALIDATION = Object.freeze({
  email: {
    required: 'Email is required',
    pattern: {
      value: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
      message: 'Please enter a valid email address',
    },
  },
  mobile: {
    required: 'Mobile number is required',
    pattern: {
      value: /^[0-9]{10}$/,
      message: 'Please enter a valid 10-digit mobile number',
    },
  },
  street: {
    required: 'Street address is required',
    pattern: {
      value: /[A-Za-z0-9]+/,
      message: 'Please enter a valid street address',
    },
  },
  city: {
    required: 'City is required',
    pattern: {
      value: /[A-Za-z]+/,
      message: 'Please enter a valid city name',
    },
  },
  state: {
    required: 'State is required',
  },
  zip: {
    required: 'ZIP code is required',
    pattern: {
      value: /^[0-9]{5}$/,
      message: 'Please enter a valid 5-digit ZIP code',
    },
  },
  cardNumber: {
    required: 'Card number is required',
  },
  cardExpiry: {
    required: 'Expiration date is required',
  },
  cardCvc: {
    required: 'Security code is required',
  },
  cardholderName: {
    required: 'Cardholder name is required',
    pattern: {
      value: /^[a-zA-Z\s]+$/,
      message: 'Please enter a valid name',
    },
  },
  termsAccepted: {
    required: 'You must accept the terms and conditions',
  },
});
